import React from "react";
import { Field } from "formik";
import PropTypes from "prop-types";
import FormField from "../fields/FormField";
import Label from "../../../atoms/label/Label";
import Tooltip from "../../../atoms/tooltip/Tooltip";

const EmailInput = props => {
  const { label, name, classes, required, tooltip } = props;

  return (
    <FormField name={name}>
      <Label text={label} id={name} required={required} />
      {tooltip && <Tooltip text={tooltip} />}
      <Field className={classes} type="email" name={name} id={name} />
    </FormField>
  );
};

EmailInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  classes: PropTypes.string,
  required: PropTypes.bool,
  tooltip: PropTypes.string
};

EmailInput.defaultProps = {
  classes: "form-item__textfield",
  required: false,
  tooltip: ""
};

export default EmailInput;
